import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type CreateGroupFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function CreateGroupFailureModal({ isOpen, handleClose }: CreateGroupFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="create-group-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.somethingWentWrong')}
        description={t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
